function openNavTab() {
    const navTab = document.querySelector('.navtab');
    if (navTab) {
        navTab.classList.add('navtab_visible');
    }
}

function closeNavTab() {
    const navTab = document.querySelector('.navtab');
    if (navTab) {
        navTab.classList.remove('navtab_visible');
    }
}

export {
    openNavTab,
    closeNavTab,
};